module.exports = __webpack_public_path__ + "img/40_38_069_900.155b1f5e.jpg";